import { FC, useEffect } from "react";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";
import { Filter } from "./Filter";
import "./CompareView.css";

interface Props {
  firstEnv: string;
  secondEnv: string;
  compareKey: string;
  firstEnvData: unknown;
  secondEnvData: unknown;
  filterItems: { value: string; label: string }[];
  onFilterChange: (filterValue: string) => void;
}

export const CompareView: FC<Props> = ({
  firstEnv,
  secondEnv,
  compareKey,
  firstEnvData,
  secondEnvData,
  filterItems,
  onFilterChange,
}) => {
  useEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, []);

  return (
    <div className="compare-view">
      <h2 className="compare-view-heading">
        Comparing <span className="compare-view-heading-span">{firstEnv}</span>{" "}
        to <span className="compare-view-heading-span">{secondEnv}</span> by{" "}
        <span className="compare-view-heading-span">{compareKey}</span>
      </h2>
      <Filter filterItems={filterItems} onFilterChange={onFilterChange} />
      <div className="compare-view-json-wrapper">
        <ReactDiffViewer
          oldValue={JSON.stringify(firstEnvData, undefined, 4)}
          newValue={JSON.stringify(secondEnvData, undefined, 4)}
          splitView={true}
          compareMethod={DiffMethod.WORDS}
          leftTitle={firstEnv.toUpperCase()}
          rightTitle={secondEnv.toUpperCase()}
        />
      </div>
    </div>
  );
};
